import services from "./services";
import areaSelect from 'area-select';
import followUpDialog from 'follow-up-dialog';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';
import schoolDetails from '../components/schoolDetails.vue';
import optOpenClassDialog from '@pages/Order/components/optOpenClassDialog/index.vue';
import official from 'official';

export default {
    mixins: [services],
    components: {
        'area-select': areaSelect,
        'follow-up-dialog': followUpDialog,
        schoolDetails,
        optOpenClassDialog,
        official
    },
    data() {
        return {
            Id: "",
            childrenId: "",
            isDisabled: false,
            isSchoolTrain: false, //判断是正式幼儿园（培训）路径
            /* 跟进情况列表 */
            followUpListVisiable: false,
            addbjbtndisabled: false,
            followUpList: [], //列表数据
            followUpTotalSize: 0, //列表总条数
            currentId: null,
            followItem: {},
            /*主页*/
            loading: false,
            lists: [], //表格内容列表{"CourseId":3,"CourseName":"英语上","SubjectId":1,"SubjectName":"英语","VolumeType":1,"VolumeTypeName":"上册"}
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            ProjectTypes: [],
            projectType: MAP_LIST.INTENT_PROJECT,
            PolicyTypes: MAP_LIST.POLICILY_TYPE,
            /*搜索*/
            IsOff: MAP_LIST.IS_OFF,
            searchVisiable: false,
            form: this.getInitFormData(),
            areaInfo: this.getInitAreaData(),
            comeList: [{
                id: -1,
                text: '全部'
            }, {
                id: 0,
                text: 'ERP新建'
            }, {
                id: 3,
                text: '代理商APP'
            }, {
                id: 4,
                text: '开通申请表'
            }, {
                id: 5,
                text: '会销申请'
            }, {
                id: 6,
                text: '培训申请'
            }],
            /* 班级 */
            GradeList: [{
                id: "1",
                text: "托班"
            }, {
                id: "2",
                text: "小班"
            }, {
                id: "4",
                text: "中班"
            }, {
                id: "8",
                text: "大班"
            }, {
                id: "16",
                text: "学前班"
            }],
            CurrentRowId: "", //表格当前选中园所
            ClassList: [], //班级列表
            dialogTableVisible: false, //表格弹窗显示
            //班级分页
            TpageIndex: 1,
            TpageSize: 10,
            TtotalSize: '',
            TpageSizes: [10, 20, 50],
            /*添加修改班级*/
            addclassVisisble: false,
            SubjectList: [],
            ActionSubject: [],
            classform: this.getClassFormData(),
            classEdit: false, //编辑课程
            classdialogContent: "", //弹窗内容
            setconfig: {
                value: "value",
                label: "name",
                children: "children"
            },
            /*班主任*/
            classCurrentRow: {}, //表格当前选中的班级
            TeacherVisible: false, //班主任弹窗的显示与隐藏
            TeacherForm: {
                Classid: "",
                UserName: "",
                PhoneNo: "",
                uid: 0,
            },
            IsScheduleDisable: false,
            SchoolCome: "",
            ContractStatusType: [{
                id: 0,
                value: '合同待审核'
            }, {
                id: 1,
                value: '合同审核通过'
            }, {
                id: 2,
                value: '合同审核不通过'
            }],
            PolicyType: [{
                    name: "联帮在线",
                    value: "1"
                },
                {
                    name: "Hi幼教",
                    value: "2",
                    children: [{
                            name: "Hi幼教A",
                            value: "1"
                        },
                        {
                            name: "Hi幼教B",
                            value: "2"
                        },
                        {
                            name: "Hi幼教C",
                            value: "4"
                        },
                        {
                            name: "Hi幼教D",
                            value: "32"
                        },
                    ]
                },
                {
                    name: "智趣坞",
                    value: "4",
                    children: [{
                            name: "图书",
                            value: "8"
                        },
                        {
                            name: "Hi-E政策",
                            value: "16"
                        }
                    ]
                },
            ],
            tabRadio: '已开课园所',
            schoolName: ''
        }
    },
    methods: {
        getInitFormData() {
            return cloneDeep({
                SchoolName: "",
                PrincipalName: "",
                PhoneNo: "",
                CTel: "",
                createTimeStart: "",
                createTimeEnd: "",
                CName: "",
                ProvId: "",
                CityId: "",
                AreaId: "",
                SchoolCome: "",
                Code: "",
                Account: "",
                AuditStatus: "",
                AgentCustomerId: "",
                ProjectTypes: "",
                IsBindDevice: "",
                IsBindUKey: "",
                IsOpenOnLineCourse: "",
                followStartDate: "",
                followEndDate: "",
                followCnt: "",
                CustomerLevel: "",
                PolicyType: "",
                ContractStatus: '', //合同审核状态
                IsOpenCourse: 1, //默认-1，已开课园所：1 未开课园所：0

            });
        },
        getInitAreaData() {
            return cloneDeep({
                Provinces_Id: '',
                City_Id: '',
                Area_Id: ''
            });
        },
        getClassFormData() {
            return cloneDeep({
                Id: 0,
                SchoolId: 0,
                ClassName: "",
                ClassNick: "",
                Grade: "",
                Subject: "",
                Option: false,
                // SN: "",
                // MAC: "",
                IsSchedule: 1,
                ProjectType: 0, //项目
                PolicyType: 0, //政策
                selectedOptions: [],
            });
        },
        handleview(item) {
            console.log(item)
            this.$refs.myofficial.Regularization({
                id: item.Id,
                isReadOnly: true
            });
        },
        // 重置密码
        ReSetPasswordFn(SchoolId) {
            this.$confirm('确定要重置密码吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.ReSetPassword(SchoolId)
            })


        },
        changePolicyType(item) {
            if (item.indexOf(2) != -1) {
                this.isDisabled = false
            } else {
                this.isDisabled = true

            }
        },

        //打开跟进情况列表
        checkFollowUpList(id) {
            this.getFollowList({
                id: id
            }); //跟进情况列表
            this.followUpListVisiable = true;
            this.currentId = id;

        },
        //更新跟进情况列表
        refreshFollowUpList(type, val) {
            let options = {
                id: this.currentId
            };
            options[type] = val;
            this.getFollowList(options);
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        }, //分页选定行
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        }, //分页监听dd页面
        ThandleSizeChange: function (val) {
            this.TpageSize = val;
            var a = {
                Sid: this.sysSid,
                Session: this.sysSession,
                SchoolId: this.CurrentRowId,
                pageSize: this.TpageSize
            };
            this.getClassList(a);
        }, //分页选定行
        ThandleCurrentChange: function (val) {
            this.TpageIndex = val;
            var a = {
                Sid: this.sysSid,
                Session: this.sysSession,
                SchoolId: this.CurrentRowId,
                pageIndex: this.TpageIndex,
                pageSize: this.TpageSize
            };
            this.getClassList(a);
        },
        //分页监听dd页面
        /*搜索*/
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        search() {
            console.log(this.form)
            this.form.ProjectTypes = this.ProjectTypes.join(",");

            // this.areaInfo = this.$refs.areaForm.getAreaData();
            // this.form.ProvId = this.areaInfo.Provinces_Id;
            // this.form.CityId = this.areaInfo.City_Id;
            // this.form.AreaId = this.areaInfo.Area_Id;
            //this.form=util.getFormSearchParams(this.form)
            //console.log(this.form)
            this.getList();
        },
        reset() {
            this.areaInfo = this.getInitAreaData();
            this.form = this.getInitFormData();
            //this.$refs.areaForm.resetFields();
            this.ProjectTypes = [];
            this.getList();
        },
        //导出功能
        download() {
            this.$confirm('确认导出吗？', '提示', {}).then(() => {
                let params = {
                    Sid: this.sysSid,
                    Session: this.sysSession
                };
                params = Object.assign({}, params, util.getFormSearchParams(this.form));
                util.exportToFileV2("api/School/SchoolDataExport", params, this)
            });
        },
        changeTab(val) {
            if (val == '未开课园所') {
                this.form.IsOpenCourse = 0
                this.getList();
            } else {
                this.form.IsOpenCourse = 1
                this.getList();
            }
        },
        /*关闭和开通联邦在线*/
        currentRow(newRow, oldRow) {
            if (!newRow) return;
            console.log(newRow)
            this.CurrentRowId = newRow.Id;
            this.schoolName = newRow.SchoolName
        },
        // 新增幼儿园（培训） schoolCome 传值6
        addSchool() {
            this.$refs.refoptOpenClassDialog.show({
                isAdd: true,
                SchoolCome: 6,
                isShowImg: true,
                isDefaultChecked: true, //平台开通申请表默认选中
                isRequired: false //平台开通申请非必填
            })
        },
        openLBZX() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: this.CurrentRowId
            };
            if (this.CurrentRowId == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择表格中要开通联邦在线的园所',
                    type: 'warning'
                })
            } else {
                this.$confirm('开通选中园所的联邦在线项目？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.open(Params);
                }).catch(() => {
                    return false;
                });
            }
        },
        closeLBZX() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: this.CurrentRowId
            };
            if (this.CurrentRowId == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择表格中要关闭联邦在线的园所',
                    type: 'warning'
                })
            } else {
                this.$confirm('关闭选中园所的联邦在线项目？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.close(Params);
                }).catch(() => {
                    return false;
                });
            }
        },
        /*班级（增加，删除，修改） */
        actionClassList() {
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                SchoolId: this.CurrentRowId,
                pageIndex: this.TpageIndex,
                pageSize: this.TpageSize
            };
            if (this.CurrentRowId == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择表格中的园所',
                    type: 'warning'
                })
            } else {
                this.getClassList(params);
                this.getSubjectList();
                this.dialogTableVisible = true;
            }
        },
        addClass() {
            this.addclassVisisble = true;
            this.classdialogContent = "添加班级";
        },
        delClass(val) {
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: val
            };
            this.$confirm('确定删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.ActionDelClass(params);
            }).catch(() => {
                return false;
            });

        },
        //处理级联选择器的值
        handleChange(value) {

            if (value.length === 2) {
                this.classform.PolicyType = value[1];
                this.classform.ProjectType = this.classform.selectedOptions[0];
            }
            if (value.length === 1) {
                this.classform.PolicyType = 0;
                this.classform.ProjectType = value[0]
            }
        },
        editClass(val) {
            this.addclassVisisble = true;
            this.classdialogContent = "修改班级";
            this.classEdit = true;
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                ClassId: val
            };
            this.ActiongetOneClass(params);
        },
        classSubmit() {
            this.classform.SchoolId = this.CurrentRowId;
            // if (this.classform.Option) {
            //     this.classform.Option = 1;
            // } else {
            //     this.classform.Option = 0;
            // }
            this.classform.Option = 0;
            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "班级名称",
                    value: this.classform.ClassName,
                    required: true
                }, {
                    name: "班级昵称",
                    value: this.classform.ClassNick,
                    required: true
                }, {
                    name: "开通项目",
                    value: this.classform.selectedOptions,
                    required: true
                }]
            });

            if (!flag) {
                return;
            }

            this.classform.Subject = this.ActionSubject.join(",");
            this.ActionclassSubmit(this.classform);
        },
        classDialogClose() {
            this.addclassVisisble = false;
            this.ActionSubject = [];
            this.classform = this.getClassFormData();
            this.classEdit = false;
        },
        TableDialogClose() {

        },
        setTeacher(item) {
            this.classCurrentRow = item;
            if ($.trim(this.classCurrentRow.ClassId).length == 0) {
                this.$notify({
                    title: "警告",
                    message: "还没有选中班级",
                    type: "warning"
                });
            } else {
                this.TeacherVisible = true;
                this.TeacherForm.UserName = this.classCurrentRow.UserName;
                this.TeacherForm.PhoneNo = this.classCurrentRow.TeacherPhone;
            }
        },
        setDisabledBtn1ByKong(value) {
            if ($.trim(value).length == 0) {
                return true;
            }
            return false;
        },
        delTeacher(item) {
            this.classCurrentRow = item;
            this.$confirm('确定删除班主任？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                var params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    classId: item.ClassId
                };
                this.ActiondelTeacher(params);

            }).catch(() => {
                return false;
            });
        },
        liveChange() {
            if (this.classform.Option) {
                this.classform.IsSchedule = 1;
                //this.IsScheduleDisable = true;
            } else {
                this.classform.IsSchedule = 0;
                //this.IsScheduleDisable = false;
            }
        },
        TeacherDialogClose() {
            this.TeacherVisible = false;
            this.TeacherForm = {
                Classid: "",
                UserName: "",
                PhoneNo: "",
                uid: 0,
            }
        },
        addTeacher() {

            this.TeacherForm.Classid = this.classCurrentRow.ClassId;

            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "班主任名称",
                    value: this.TeacherForm.UserName,
                    required: true
                }, {
                    name: "手机号码",
                    value: this.TeacherForm.PhoneNo,
                    phone: true
                }]
            });

            if (!flag) {
                return;
            }

            if (this.classCurrentRow.TeacherId == 0) {
                var Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    Classid: this.TeacherForm.Classid,
                    UserName: this.TeacherForm.UserName,
                    PhoneNo: this.TeacherForm.PhoneNo,
                    uid: 0
                };
            } else {
                var Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    Classid: this.TeacherForm.Classid,
                    UserName: this.TeacherForm.UserName,
                    PhoneNo: this.TeacherForm.PhoneNo,
                    uid: this.classCurrentRow.TeacherId
                };
            }
            this.ActionAddTeacher(Params);
        },
        handleEdit(item) {
            this.childrenId = item.Id;
            this.$refs.myofficial.Regularization({
                id: item.Id,
                changeForm: true
            });

        },
        Submit() {
            this.Update_ModifySchool(this.submitform);
        },
        // 判断路径
        changeFlag() {
            if (this.$route.path == "/school/SchoolTrain") {
                this.isSchoolTrain = true;
            } else {
                this.isSchoolTrain = false;

            }
        }
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        AgentList() {
            return this.$store.state.AgentList;
        },
        allProvince() {
            return this.$store.state.allProvince;
        },
        customerLevelList() {
            return this.$store.state.customerLevelList;
        },
    },
    //组件初始化
    created() {
        this.getList();
    },
    watch: {
        $route(to, from) {
            this.form.SchoolCome = ''
            this.changeFlag()
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/officialSchool/vm.js